import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { OktaAuthService } from '@okta/okta-angular';
import { SubNavStateService } from './sub-nav-state.service';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { BreadCrumb } from '../models/bread-crumb.Model';

@Component({
  selector: 'sub-nav-full-width',
  templateUrl: './sub-nav-full-width.component.html',
  styleUrls: ['./sub-nav-full-width.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubNavFullWidthComponent implements OnInit {

  constructor(private authService: OktaAuthService, private breadCrumbSvc: SubNavStateService) { }

  user$ = this.authService.getUser();
  breadCrumb$: Observable<BreadCrumb[]> = this.breadCrumbSvc.breadCrumbListStream.pipe(
    tap(x=> console.log('Breadcrumb stream event: ', x))
  );

  ngOnInit() {
  }

  logout() {
    this.authService.logout('/login');
    const token = localStorage.getItem('token');
  }
}
